import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EmployeeInfoService {
  private EmployeeInfo;
  constructor() {}

  public setEmployeeInfo(value) {
    this.EmployeeInfo = value;
  }

  public getEmployeeInfo() {
    return this.EmployeeInfo;
  }
}
